export enum BitmojiAppSnapchatUpsellActionEnum {
  BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_UNKNOWN = 'BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_UNKNOWN',
  BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_IMPRESSION = 'BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_IMPRESSION',
  BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_CLICK = 'BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_CLICK',
  BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_DISMISS = 'BITMOJI_APP_SNAPCHAT_UPSELL_ACTION_DISMISS',
}
